const footerDropdownButtons = document.querySelectorAll('.footer-menu-dropdown-button');

footerDropdownButtons.forEach(button => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (e.target.ariaSelected === 'false' || !e.target.ariaSelected) {
            e.target.ariaSelected = true;
            if (e.target.nextElementSibling) {
                e.target.nextElementSibling.nextElementSibling.style.display = 'block';
                e.target.style.height = '1rem';
            } else {
                e.target.parentElement.nextElementSibling.nextElementSibling.style.display = 'block';
                e.target.parentElement.style.height = '1rem';
            }
        } else {
            if (e.target.nextElementSibling) {
                e.target.ariaSelected = false;
                e.target.nextElementSibling.nextElementSibling.style.display = 'none';
                e.target.style.height = 'auto';
            } else {
                e.target.parentElement.ariaSelected = false;
                e.target.parentElement.nextElementSibling.nextElementSibling.style.display = 'none';
                e.target.parentElement.style.height = 'auto';
            }
        }
    })
})